var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('div',{staticClass:"embedtool"},[_c('iframe',{staticStyle:{"border":"none !important"},attrs:{"src":_vm.videoUrl,"allowfullscreen":"","frameBorder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }